import { useQuery } from "@tanstack/react-query";

import { getPatientIntakeConsultationSummary } from "~/providers/api";

export const useGetPatientIntakeConsultationSummary = (
  consultationId?: string,
  enabled?: boolean,
) => {
  const { data, isLoading } = useQuery({
    queryFn: () => getPatientIntakeConsultationSummary(consultationId),
    queryKey: ["getPatientIntakeConsultationSummary", consultationId],
    enabled,
  });
  return { data, isLoading };
};
